import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import React, {useEffect} from "react";
import Table from "../../components/common/table/Table";
import {useDispatch, useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import {
    fetchAllTransactionType,
    deleteTransactionType,
    resetCreateStatus,
    resetUpdateStatus
} from "../../store/transaction-type-slice";
import {getTableColumns, getTableData} from "../../models/transactionTypeModel";
import ActionDropdown from "../../components/actions/ActionDropdown";

const TransactionTypeView = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();

    const {
        items,
        fetchStatus,
        createStatus,
        updateStatus,
        pagination,
        error
    } = useSelector(state => state.transactionType);

    const userRole = useSelector((state) => state.auth.selectedRole);
    //set initial page and limit
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialLimit = Number(searchParams.get("limit")) || 25;

    useEffect(() => {
        dispatch(fetchAllTransactionType({
            ...userRole,
            page: initialPage,
            limit: initialLimit
        }));
    }, [dispatch, userRole, initialPage, initialLimit]);

    useEffect(() => {
        if (createStatus === "success") {
            dispatch(resetCreateStatus());
        }
    }, [dispatch, createStatus]);

    useEffect(() => {
        if (updateStatus === "success") {
            dispatch(resetUpdateStatus());
        }
    }, [dispatch, updateStatus]);

    const deleteHandler = (id) => {
        dispatch(deleteTransactionType({...userRole, id: id}));
    };

    const tableColumns = getTableColumns({ActionDropdown, deleteHandler});
    const tableData = getTableData({items});

    return (
        <>
            <SubHeader title="All Transaction Type">
                <Button to="add" className="btn-sm bg-primary bg-opacity-50">Add New</Button>
            </SubHeader>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" && (
                <Table
                    className="mobile-responsive"
                    columns={tableColumns}
                    data={tableData}
                    pagination={pagination}
                />
            )}
        </>
    )
}

export default TransactionTypeView;